<template>
  <lsm-widget
    :title="t('course.training_confirmation')"
    :subtitle="courseSession.course?.name"
    icon="fa-chalkboard-teacher"
    data-testid="course-session-confirmation-widget"
  >
    <div>
      {{ t('course.please_confirm_attendance', { date: toLongDateWithDay(courseSession.date) }) }}
    </div>
    <div v-if="confirmed">
      <v-icon
        color="success"
        size="small"
        icon="fas fa-check-circle"
      /> {{ t('course.attendance_confirmation_success') }}
    </div>
    <v-dialog
      v-if="!confirmed"
      v-model="dialog"
      max-width="500px"
      activator="#confirm"
    >
      <global-card
        :title="t('course.confirm_attendance')"
        closable
        @close="close"
      >
        <v-text-field
          v-model="confirmationCode"
          :label="t('course.confirmation_code')"
          class="mb-n10"
        />
        <template #actions>
          <v-btn
            :text="t('actions.close')"
            color="dark-grey"
            @click="close"
          />
          <v-btn
            :text="t('course.confirm_button')"
            color="primary"
            @click="confirmAttendance"
          />
        </template>
      </global-card>
    </v-dialog>
    <template
      v-if="!confirmed"
      #buttons
    >
      <v-btn
        id="confirm"
        color="primary"
        :text="t('course.confirm_attendance')"
      />
    </template>
  </lsm-widget>
</template>

<script setup lang="ts">
import axios from 'axios';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuth, useDate } from '@/composables';
import { useErrorStore } from '@/stores/errors';
import LsmWidget from './LsmWidget.vue';

const props = defineProps<{
  courseSession: App.Models.CourseSession;
}>();

const { t } = useI18n();

const { authUser } = useAuth();
const { toLongDateWithDay } = useDate();
const { handleError } = useErrorStore();

const dialog = ref<boolean>(false);
const confirmed = ref<boolean>(false);
const confirmationCode = ref<string>('');

function close() {
  dialog.value = false;
}

async function confirmAttendance() {
  const url = `/api/coursesessions/${props.courseSession.id}/confirm`;
  try {
    await axios.put(url, { user_id: authUser.id, confirmation_code: confirmationCode.value });
    confirmed.value = true;
    close();
  }
  catch (error) {
    handleError(error, t('course.attendance_confirmation_error'));
  }
}
</script>
